import '../../assets/index20.css';var K = Object.defineProperty, L = Object.defineProperties;
var U = Object.getOwnPropertyDescriptors;
var p = Object.getOwnPropertySymbols;
var z = Object.prototype.hasOwnProperty, G = Object.prototype.propertyIsEnumerable;
var W = (r, a, n) => a in r ? K(r, a, { enumerable: !0, configurable: !0, writable: !0, value: n }) : r[a] = n, g = (r, a) => {
  for (var n in a || (a = {}))
    z.call(a, n) && W(r, n, a[n]);
  if (p)
    for (var n of p(a))
      G.call(a, n) && W(r, n, a[n]);
  return r;
}, T = (r, a) => L(r, U(a));
var Q = (r, a) => {
  var n = {};
  for (var t in r)
    z.call(r, t) && a.indexOf(t) < 0 && (n[t] = r[t]);
  if (r != null && p)
    for (var t of p(r))
      a.indexOf(t) < 0 && G.call(r, t) && (n[t] = r[t]);
  return n;
};
import { jsxs as d, jsx as e, Fragment as M } from "react/jsx-runtime";
import { Button as c } from "../Button/index.js";
import { Title as X } from "../Title/index.js";
import { PaperPlaneTopFarFAIcon as A, TriangleExclamationFarFAIcon as V, TrashFarFAIcon as ee, XMarkFarFAIcon as re } from "../Icons/index.js";
import { forwardRef as ae, useEffect as ne } from "react";
import { T as b } from "../../Transition-esp-rpzm.js";
import { P as te } from "../../Portal-CZ-iZqfA.js";
import { S as j } from "../../Stack-CTaaXTID.js";
const oe = "Modal-module__wrapper___rdgyn", le = "Modal-module__overlay___9MGnZ", de = "Modal-module__modal___ET0NO", ie = "Modal-module__header___icaSI", ce = "Modal-module__title___NGy-S", se = "Modal-module__closeButton___lXGNX", _e = "Modal-module__contentWrapper___yTMd3", me = "Modal-module__footer___yQ3IF", ve = "Modal-module__variantContainer___MC0Id", he = "Modal-module__variantTitle___Oh8TJ", fe = "Modal-module__variantMessage___6-Dwd", ue = "Modal-module__variantActions___0s9QG", pe = "Modal-module__variantIcon___Qqtla", l = {
  wrapper: oe,
  overlay: le,
  modal: de,
  header: ie,
  title: ce,
  closeButton: se,
  contentWrapper: _e,
  footer: me,
  variantContainer: ve,
  variantTitle: he,
  variantMessage: fe,
  variantActions: ue,
  variantIcon: pe
}, ge = ae((Me, Z) => {
  var E = Me, {
    centered: r = !0,
    children: a,
    className: n,
    classNames: t = {},
    onClose: m,
    opened: _,
    position: O = "center",
    size: P = "360px",
    title: v,
    actions: C = [],
    variant: s = "default",
    message: F,
    primaryActionLabel: k,
    secondaryActionLabel: $,
    onPrimaryAction: y,
    onSecondaryAction: w,
    transition: S = "slide-up",
    transitionDuration: I = 200,
    transitionTimingFunction: x = "ease",
    confirmationIcon: q = /* @__PURE__ */ e(A, { size: 16 }),
    warningIcon: D = /* @__PURE__ */ e(V, { size: 16 }),
    dangerIcon: J = /* @__PURE__ */ e(ee, { size: 16 }),
    primaryActionVariant: h = "accent",
    secondaryActionVariant: N = "tertiary",
    withinPortal: R = !0
  } = E, Y = Q(E, [
    "centered",
    "children",
    "className",
    "classNames",
    "onClose",
    "opened",
    "position",
    "size",
    "title",
    "actions",
    "variant",
    "message",
    "primaryActionLabel",
    "secondaryActionLabel",
    "onPrimaryAction",
    "onSecondaryAction",
    "transition",
    "transitionDuration",
    "transitionTimingFunction",
    "confirmationIcon",
    "warningIcon",
    "dangerIcon",
    "primaryActionVariant",
    "secondaryActionVariant",
    "withinPortal"
  ]);
  ne(() => {
    const i = (f) => {
      f.key === "Escape" && _ && m();
    };
    return _ && (document.body.style.overflow = "hidden", document.addEventListener("keydown", i)), () => {
      document.body.style.overflow = "unset", document.removeEventListener("keydown", i);
    };
  }, [_, m]);
  const H = () => {
    if (s === "default") {
      const i = C.filter((o) => o.position === "left"), f = C.filter((o) => o.position !== "left");
      return /* @__PURE__ */ d(M, { children: [
        v && /* @__PURE__ */ d("div", { className: `${l.header} ${t.header || ""}`, children: [
          /* @__PURE__ */ e(X, { order: 4, className: l.title, children: v }),
          /* @__PURE__ */ e(
            c,
            {
              className: l.closeButton,
              onClick: m,
              variant: "tertiary",
              size: "lg",
              children: /* @__PURE__ */ e(re, {})
            }
          )
        ] }),
        /* @__PURE__ */ e("div", { className: `${l.contentWrapper} ${t.body || ""}`, children: a }),
        C.length > 0 && /* @__PURE__ */ d("div", { className: `${l.footer} ${t.footer || ""}`, children: [
          i.map((o, u) => /* @__PURE__ */ e(
            c,
            {
              variant: o.variant || "tertiary",
              onClick: o.onClick,
              danger: o.danger,
              style: { marginLeft: "-0.5rem" },
              children: o.label
            },
            `left-${u}`
          )),
          /* @__PURE__ */ e("div", { style: { flex: 1 } }),
          f.map((o, u) => /* @__PURE__ */ e(
            c,
            {
              variant: o.variant || (u === f.length - 1 ? "accent" : "secondary"),
              onClick: o.onClick,
              danger: o.danger,
              children: o.label
            },
            `right-${u}`
          ))
        ] })
      ] });
    }
    return /* @__PURE__ */ d("div", { className: `${l.variantContainer} ${t.body || ""}`, children: [
      /* @__PURE__ */ d(j, { className: l.variantIcon, "data-variant": s, children: [
        s === "confirmation" && q,
        s === "warning" && D,
        s === "danger" && J
      ] }),
      /* @__PURE__ */ d(j, { gap: "xxs", children: [
        v && /* @__PURE__ */ e(X, { order: 4, className: l.variantTitle, children: v }),
        F && /* @__PURE__ */ e("p", { className: l.variantMessage, children: F })
      ] }),
      /* @__PURE__ */ d("div", { className: l.variantActions, children: [
        s === "confirmation" && /* @__PURE__ */ d(M, { children: [
          /* @__PURE__ */ e(c, { variant: N, onClick: w, children: $ || "Edit" }),
          /* @__PURE__ */ e(c, { variant: h, onClick: y, children: k })
        ] }),
        s === "warning" && /* @__PURE__ */ d(M, { children: [
          /* @__PURE__ */ e(c, { variant: N, onClick: w, children: $ || "Cancel" }),
          /* @__PURE__ */ e(c, { variant: h, onClick: y, children: k || "Leave" })
        ] }),
        s === "danger" && /* @__PURE__ */ d(M, { children: [
          /* @__PURE__ */ e(c, { variant: N, onClick: w, children: $ || "Cancel" }),
          /* @__PURE__ */ e(c, { danger: h === "primary", variant: h, onClick: y, children: k || "Delete" })
        ] })
      ] })
    ] });
  }, B = /* @__PURE__ */ d("div", { className: `${l.wrapper} ${t.wrapper || ""}`, children: [
    /* @__PURE__ */ e(
      b,
      {
        mounted: _,
        transition: "fade",
        duration: I,
        timingFunction: x,
        children: (i) => /* @__PURE__ */ e("div", { className: `${l.overlay} ${t.overlay || ""}`, onClick: m, style: i })
      }
    ),
    /* @__PURE__ */ e(
      b,
      {
        mounted: _,
        transition: S,
        duration: I,
        timingFunction: x,
        children: (i) => /* @__PURE__ */ e(
          "div",
          T(g({
            className: `${l.modal} ${n || ""}`,
            style: g(T(g({}, i), {
              maxWidth: P
            }), O === "center" && r ? {
              top: "50%",
              transform: `${i.transform || ""} translateY(-50%)`
            } : {}),
            ref: Z
          }, Y), {
            children: H()
          })
        )
      }
    )
  ] });
  return R ? /* @__PURE__ */ e(te, { children: B }) : B;
});
ge.displayName = "Modal";
export {
  ge as Modal
};
